import { render } from "./Navbar.vue?vue&type=template&id=a461daa6"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Allgemein\\Ich\\Hobbys\\Programmieren\\Web Development\\little-projects\\vue-test-router\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__